export { defineAgentClient } from "@/agent/client/builder";
export { createLifeClient } from "@/client/create";
export { definePluginClient } from "@/plugins/client/builder";

import { generationPluginClient } from "@/plugins/defaults/generation/client";
import { memoriesPluginClient } from "@/plugins/defaults/memories/client";
import { storesPluginClient } from "@/plugins/defaults/stores/client";

// Explicit typing is required to avoid type size explosion with the iterator
export type ClientPluginsDefaults = {
  readonly generation: typeof generationPluginClient;
  readonly memories: typeof memoriesPluginClient;
  readonly stores: typeof storesPluginClient;
  readonly [Symbol.iterator]: () => Generator<
    typeof generationPluginClient | typeof memoriesPluginClient | typeof storesPluginClient,
    void,
    unknown
  >;
};

export const defaults: { readonly plugins: ClientPluginsDefaults } = {
  plugins: {
    generation: generationPluginClient,
    memories: memoriesPluginClient,
    stores: storesPluginClient,
    *[Symbol.iterator]() {
      for (const entry of Object.values(this)) yield entry;
    },
  },
};

// Types
export type { AgentClient } from "@/agent/client/class";
export type {
  AgentClientFromBuild,
  AgentClientParam,
} from "@/agent/client/types";
export { parseAgentClientParam } from "@/agent/client/types";
export type { LifeClient } from "@/client/client";
export type { Message } from "@/shared/messages";
